import React from "react";

function GradientTick() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
    >
      <path
        d="M1.5 6.25L6.5 11.25L16.5 0.75"
        stroke="url(#paint0_linear_1459_52254)"
        stroke-width="2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1459_52254"
          x1="1.5"
          y1="6.05102"
          x2="16.5002"
          y2="6.00911"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#22C1C3" />
          <stop offset="1" stop-color="#6EF195" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GradientTick;
